import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  margin-bottom: 20px;
`;

export const ModalButtons = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

// Mensagem de "falta cidade" dentro do modal. Cor literal: os temas common e
// admin não compartilham tokens de feedback, e este modal é reusado nos dois
// (o formulário da seletiva usa este componente com variant="light").
export const Error = styled.span`
  display: block;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: bold;
  color: ${({ variant }) => (variant === "light" ? "#A81423" : "#FF6B6B")};
`;
